export const button = `
  group
  font-normal rounded inline-flex items-center justify-center cursor-pointer
  bg-transparent border-0 box-border h-10 py-0 px-3
  text-ll-font-size-p

  disabled:cursor-default

  data-[size=small]:h-8
  data-[size=small]:px-2
  data-[size=small]:text-ll-font-size-caption-1

  data-[size=large]:h-12
  data-[size=large]:px-4

  data-[variant=contained]:bg-ll-primary
  data-[variant=contained]:text-ll-on-primary
  data-[variant=contained]:border
  data-[variant=contained]:border-solid
  data-[variant=contained]:border-transparent
  data-[variant=contained]:hover:bg-ll-primary-variant1
  data-[variant=contained]:disabled:bg-ll-disabled
  

  data-[variant=outlined]:bg-ll-background
  data-[variant=outlined]:text-ll-primary
  data-[variant=outlined]:border
  data-[variant=outlined]:border-solid
  data-[variant=outlined]:border-ll-primary
  data-[variant=outlined]:hover:bg-ll-surface-variant1
  data-[variant=outlined]:disabled:bg-ll-disabled
  data-[variant=outlined]:disabled:text-ll-on-primary
  data-[variant=outlined]:disabled:border-ll-on-background

  data-[variant=text]:text-ll-on-background
`;

export const iconContainer = `
  flex items-center mr-2 ml-1
  [&>svg]:fill-current [&>svg]:h-5 [&>svg]:w-5

  group-data-[size=small]:[&>svg]:h-3
  group-data-[size=small]:[&>svg]:w-3

  group-data-[size=large]:[&>svg]:h-6
  group-data-[size=large]:[&>svg]:w-6
`;
